"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require("semantic-ui-react");

var _reactWeathericons = require("react-weathericons");

var _reactWeathericons2 = _interopRequireDefault(_reactWeathericons);

var _PanelButtonsVisualizations = require("./PanelButtonsVisualizations.css");

var _PanelButtonsVisualizations2 = _interopRequireDefault(_PanelButtonsVisualizations);

var _constants = require("../../utils/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//     

var PanelButtonsVisualizations = function (_Component) {
	_inherits(PanelButtonsVisualizations, _Component);

	function PanelButtonsVisualizations() {
		_classCallCheck(this, PanelButtonsVisualizations);

		return _possibleConstructorReturn(this, (PanelButtonsVisualizations.__proto__ || Object.getPrototypeOf(PanelButtonsVisualizations)).call(this));
	}

	_createClass(PanelButtonsVisualizations, [{
		key: "onclickBTViusalization",
		value: function onclickBTViusalization(index) {

			if (!this.props.isEditor) {
				this.props.visualitzacioVisibleChanged(index);
			}
		}
	}, {
		key: "renderButtons",
		value: function renderButtons(value) {
			var _this2 = this;

			var itemH = [];
			var bottons = this.props.thematicoptions;

			if (value !== _constants.BUTTONS_TYPE_BLANC) {

				if (value === _constants.BUTTONS_TYPE_ICONES) {

					var buttonSize = this.props.width >= _constants.MAX_WIDTH_SCREEN_SIZE_LEGEND ? "huge" : "medium";
					bottons.map(function (button, index) {
						return itemH.push(_react2.default.createElement(
							_semanticUiReact.Button,
							{
								size: buttonSize, key: index, onClick: function onClick() {
									return _this2.onclickBTViusalization(index);
								},
								className: _this2.props.currentVis === index ? _PanelButtonsVisualizations2.default.myActiveButton80 : _PanelButtonsVisualizations2.default.myInactiveButton80
							},
							_react2.default.createElement(_reactWeathericons2.default, { name: button.visualization.weathericon, className: _this2.props.currentVis === index ? _PanelButtonsVisualizations2.default[button.visualization.weathercoloricon] : [_PanelButtonsVisualizations2.default[button.visualization.weathercoloricon], _PanelButtonsVisualizations2.default.opacityMig].join(" ") })
						));
					});
				} else if (value === _constants.BUTTONS_TYPE_ICONESTEXT) {

					var _buttonSize = this.props.width >= _constants.MAX_WIDTH_SCREEN_SIZE_LEGEND ? "large" : "small";
					bottons.map(function (button, index) {
						return itemH.push(_react2.default.createElement(
							_semanticUiReact.Button,
							{
								size: _buttonSize,
								key: index,
								onClick: function onClick() {
									return _this2.onclickBTViusalization(index);
								},
								className: _this2.props.currentVis === index ? _PanelButtonsVisualizations2.default.myActiveButton : _PanelButtonsVisualizations2.default.myInactiveButton
							},
							_react2.default.createElement(
								"span",
								{ className: _this2.props.currentVis === index ? _PanelButtonsVisualizations2.default[button.visualization.weathercoloricon] : [_PanelButtonsVisualizations2.default[button.visualization.weathercoloricon], _PanelButtonsVisualizations2.default.opacityMig].join(" ") },
								_react2.default.createElement(_reactWeathericons2.default, { name: button.visualization.weathericon }),
								_react2.default.createElement(
									"span",
									{ className: _PanelButtonsVisualizations2.default.labelBT },
									button.title
								)
							)
						));
					});
				} else if (value === _constants.BUTTONS_TYPE_TEXT) {

					var _buttonSize2 = this.props.width >= _constants.MAX_WIDTH_SCREEN_SIZE_LEGEND ? "large" : "small";
					bottons.map(function (button, index) {
						return itemH.push(_react2.default.createElement(
							_semanticUiReact.Button,
							{
								size: _buttonSize2,
								key: index,
								onClick: function onClick() {
									return _this2.onclickBTViusalization(index);
								},
								className: _this2.props.currentVis === index ? _PanelButtonsVisualizations2.default.myActiveButton : _PanelButtonsVisualizations2.default.myInactiveButton
							},
							_react2.default.createElement(
								"span",
								{ className: _this2.props.currentVis === index ? _PanelButtonsVisualizations2.default[button.visualization.weathercoloricon] : [_PanelButtonsVisualizations2.default[button.visualization.weathercoloricon], _PanelButtonsVisualizations2.default.opacityMig].join(" ") },
								button.title
							)
						));
					});
				}

				return itemH;
			}
		}
	}, {
		key: "render",
		value: function render() {

			return _react2.default.createElement(
				"div",
				{ className: _PanelButtonsVisualizations2.default.panelButtons, style: { left: this.props.isEditor ? "30%" : "15px", bottom: this.props.isEditor ? "90px" : "5px" }, id: "panelInfo" },
				this.renderButtons(this.props.layoutoptions.opvisual)
			);
		}
	}]);

	return PanelButtonsVisualizations;
}(_react.Component);

exports.default = PanelButtonsVisualizations;


PanelButtonsVisualizations.propTypes = {
	layoutoptions: _propTypes2.default.object,
	thematicoptions: _propTypes2.default.array,
	isEditor: _propTypes2.default.bool,
	visualitzacioVisibleChanged: _propTypes2.default.func,
	currentVis: _propTypes2.default.number,
	width: _propTypes2.default.number
};
